module.exports = __webpack_public_path__ + "static/media/capy_page_area03_img_en@2x.581eeb0c.jpg";